
import React from 'react';
import { Toolbar } from '@material-ui/core';
import { CollectionItemHeader } from 'components/layout';
import AppLoader from 'components/basic/AppLoader';
import ThematicPackageTraitTransferList from '../ThematicPackageTraitTransferList';
import { useItem } from '../../../../hooks/atoms/item-hook';
import CollectionKeys from '../../../../hooks/molecules/collection-keys';

function TraitsPerThematicList(
  {
    id,
  },
) {
  const {
    item: thematicPackage,
    itemIsLoading: isLoading,
    itemError: error,
  } = useItem(CollectionKeys.THEMATIC_PACKAGES, id);

  if (isLoading) {
    return <AppLoader />;
  }

  if (!thematicPackage) {
    return <AppLoader />;
  }

  if (error) {
    return <div>Not Found</div>;
  }

  return (
    <>
      <CollectionItemHeader
        title={ `Name: ${ thematicPackage.name }` }
        subtitle={ `Description: ${ thematicPackage.description }` }
      />
      <Toolbar />
      <ThematicPackageTraitTransferList id={ thematicPackage.id } />
    </>
  );
}

export default TraitsPerThematicList;

